import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var searchService = /** @class */ (function () {
    function searchService(http, localSt) {
        this.http = http;
        this.localSt = localSt;
        this.serverUrl = environment.serverUrl;
    }
    searchService.prototype.findItems = function (value, date) {
        return this.http.get(this.serverUrl + 'items/withcategoryandsearch?page=1&limit=10&search=' + value + '&date=' + date + '&order=desc');
    };
    return searchService;
}());
export { searchService };



// WEBPACK FOOTER //
// ./src/app/services/search.service.ts.pre-build-optimizer.js